import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCalendar = () => {
  return (
    <g>
      <path d="m13.6943 1.38h-1.5343v-.5958a.7.7 0 0 0 -1.4 0v.5958h-5.52v-.5958a.7.7 0 0 0 -1.4 0v.5958h-1.5343a1.7021 1.7021 0 0 0 -1.7 1.7v11.1358a1.7021 1.7021 0 0 0 1.7 1.7h11.3886a1.7021 1.7021 0 0 0 1.7-1.7v-11.1358a1.7021 1.7021 0 0 0 -1.7-1.7zm-11.3886 1.4h1.5343v.5967a.7.7 0 0 0 1.4 0v-.5967h5.52v.5967a.7.7 0 0 0 1.4 0v-.5967h1.5342a.303.303 0 0 1 .3.3v1.8721h-11.9883v-1.8721a.3031.3031 0 0 1 .2998-.3zm11.3886 11.7356h-11.3886a.303.303 0 0 1 -.3-.3v-7.8631h11.9884v7.8633a.303.303 0 0 1 -.2998.2998z" />
      <path d="m8.3125 7.291a.7011.7011 0 0 0 -.75.1113l-1.36 1.19a.7.7 0 1 0 .9215 1.0532l.1992-.1738v3.63a.7.7 0 1 0 1.4 0v-5.173a.701.701 0 0 0 -.4107-.6377z" />
    </g>
  );
};

export default withIcon(IconCalendar);
